export default __webpack_public_path__ + "static/media/upload.04de29f9.webp";